module.exports = __webpack_public_path__ + "img/1512059677.5d910802.jpg";